import Header from "@/components/site/Header";
import LoadingScreen from "@/components/site/LoadingScreen";
import Hero from "@/components/site/Hero";
import Acronym from "@/components/site/Acronym";
import GlobalReach from "@/components/site/GlobalReach";
import AboutUs from "@/components/site/AboutUs";
import Milestones from "@/components/site/Milestones";
import WhyChooseUs from "@/components/site/WhyChooseUs";
import Services from "@/components/site/Services";
import Facilities from "@/components/site/Facilities";
import Products from "@/components/site/Products";
import QualityLab from "@/components/site/QualityLab";
import Certifications from "@/components/site/Certifications";
import LogisticsCompliance from "@/components/site/LogisticsCompliance";
import Leadership from "@/components/site/Leadership";
import Clients from "@/components/site/Clients";
import Contact from "@/components/site/Contact";
import RFQForm from "@/components/site/RFQForm";
import Footer from "@/components/site/Footer";

export default function HomePage() {
  return (
    <div data-testid="home-page" className="relative bg-brand-bg">
      <LoadingScreen />
      <Header />
      <main>
        {/* Home */}
        <Hero />
        <Acronym />
        <GlobalReach />

        {/* About */}
        <AboutUs />
        <Milestones />
        <WhyChooseUs />
        <Services />

        {/* Facilities */}
        <Facilities />

        {/* Products */}
        <Products />

        {/* Quality */}
        <QualityLab />
        <Certifications />

        {/* Logistics */}
        <LogisticsCompliance />

        {/* Leadership */}
        <Leadership />

        {/* Customers */}
        <Clients />

        {/* Contact */}
        <Contact />

        {/* Request RFQ */}
        <RFQForm />
      </main>
      <Footer />
    </div>
  );
}
